import { VerticalProgressStep } from 'modules/common/components/VerticalProgressStepper/VerticalProgressStep/VerticalProgressStep'
import { EnumVerticalStepStatus } from 'modules/common/components/VerticalProgressStepper/VerticalProgressStep/VerticalProgressStep.theme'
import { VerticalProgressStepper } from 'modules/common/components/VerticalProgressStepper/VerticalProgressStepper'
import { useTranslation } from 'modules/common/hooks/useTranslation'

export const SponsorshipStepper = () => {
  const { t } = useTranslation('settings-components')

  const steps = t('sponsorshipProcessContainer.steps', {
    returnObjects: true,
  })

  return (
    <VerticalProgressStepper className="max-w-md text-left">
      {steps.map(({ title, description }, index) => {
        const icons = { [EnumVerticalStepStatus.INFO]: index + 1 }

        return (
          <VerticalProgressStep
            key={index}
            icons={icons}
            description={description}
            status={EnumVerticalStepStatus.INFO}
            title={title}
          />
        )
      })}
    </VerticalProgressStepper>
  )
}
